import { spError } from '@eventr/common'
import { StateCreator } from 'zustand'
import { DataAPI, DEBUG_RENDER_OPTIONS, ISection } from '../data/Data'
import mobileRenderFields from '../feat/editItinerary/ExampleMobileRenderFields.json'
import { BoundStore } from './bound.store'
interface SectionState {
    sections: ISection[]
    selectedSection: number | undefined
}

interface SectionActions {
    getSection: (id: number) => ISection | undefined
    checkIfAllDynamicSectionsEmpty: () => boolean
    fetchSections: () => Promise<void>
}
export interface ISectionSlice extends SectionState, SectionActions { }
export const createSectionSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    ISectionSlice
> = (set, get) => ({
    sections: [],
    selectedSection: undefined,

    fetchSections: async () => {
        const sections = await DataAPI.getSections().catch((e) => {
            return null
        })

        if (DEBUG_RENDER_OPTIONS && sections) {
            sections.forEach((section) => {
                if (section.properties) {
                    section.properties.mobileEditFieldOptions =
                        mobileRenderFields[section.name as keyof typeof mobileRenderFields]
                }
            })
        }

        if (sections) {
            set({ sections }, false, 'fetchSections')
        } else {
            spError('Failed to fetch sections')
        }
    },

    getSection: (id: number) => {
        return get().sections.find((section) => section.id === id)
    },
    checkIfAllDynamicSectionsEmpty: () => {
        const { selectedItinerary } = get()
        if (
            !selectedItinerary ||
            !selectedItinerary.v2 ||
            selectedItinerary.v2.length === 0
        ) {
            return true
        }

        for (const e of selectedItinerary.v2) {
            if (e.sectionName !== 'event_information') {
                if (
                    e.data &&
                    Object.keys(e.data).some((key) => e.data[key].length > 0)
                ) {
                    return false
                }
            }
        }

        return true
    },
})
